import { NavigationItem } from './types';

export const isNavigationItemActive = (item: NavigationItem, pathname: string | null) => {
	return !!pathname && !!item.href && pathname.includes(item.href);
};
